import React from 'react';
import { motion } from 'framer-motion';

const stats = [
    { k: '156', l: 'países presentes', s: '9 pabellones temáticos' },
    { k: '255K', l: 'visitantes anuales', s: 'flujo global de FITUR' },
    { k: '155K', l: 'profesionales del turismo', s: 'compradores y decisores' },
    { k: '9.500', l: 'empresas expositoras', s: 'todas buscando lo mismo que tú' },
];

const FiturScale = () => (
    <section id="oceano" className="relative py-16 md:py-20 overflow-hidden">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <div className="grid grid-cols-12 gap-5 md:gap-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 0.7 }}
                    className="col-span-12 md:col-span-5"
                >
                    <div className="eyebrow-brand mb-6">El terreno de juego</div>
                    <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                        FITUR es enorme.<br />
                        <span className="italic-accent text-[color:var(--brand)] font-normal">Ir solo, un error.</span>
                    </h2>
                    <p className="mt-8 max-w-[46ch] text-white/80 text-lg leading-relaxed">
                        Lo realmente costoso no es el pasaje. Es regresar sin contactos relevantes,
                        sin aprendizajes y sin un plan para convertir conversaciones en oportunidades.
                    </p>
                </motion.div>

                <div className="col-span-12 md:col-span-7 grid grid-cols-2 gap-px bg-white/10">
                    {stats.map((s, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-80px' }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="group relative bg-[color:var(--bg)] p-8 md:p-10 min-h-[220px] flex flex-col justify-between overflow-hidden"
                        >
                            <div className="absolute -bottom-16 -right-8 h-40 w-40 rounded-full bg-[color:var(--brand)]/0 transition-colors duration-500 group-hover:bg-[color:var(--brand)]/12" />
                            <div className="overline text-white/50">{`0${i + 1}`}</div>
                            <div>
                                <div className="num-display text-white text-2xl md:text-3xl">
                                    {s.k}
                                </div>
                                <div className="mt-3 text-sm text-white/80">{s.l}</div>
                                <div className="mt-1 text-xs text-white/45">{s.s}</div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default FiturScale;
